import { useEffect } from 'react';
import { engine, useEngine } from './hooks/useEngine.ts';
import { CallStage } from './components/CallStage.tsx';
import { Landing } from './components/Landing.tsx';
import { ReconnectPrompt } from './components/Reunion.tsx';
import { Toasts } from './components/Toasts.tsx';

export default function App() {
  const state = useEngine();
  const inSession =
    state.phase === 'searching' || state.phase === 'connecting' || state.phase === 'live';

  // Hold a presence socket from the first paint: it keeps the landing numbers
  // live and, more importantly, lets a past spark reach you while you're idle.
  useEffect(() => engine.wake(), []);

  return (
    <>
      {inSession ? <CallStage /> : <Landing />}
      <ReconnectPrompt reconnect={state.reconnect} />
      <Toasts notice={state.notice} badges={state.badgeToasts} />
      {state.connection === 'reconnecting' && (
        <div className="pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden bg-phidio-900">
          <div className="h-full w-1/3 bg-phidio-500 animate-scan" />
        </div>
      )}
    </>
  );
}
